<div class="lm-facade-detail-wrapper">
    <div class="lm-facade-detail-title">
        <h3 class="lm-bold lm-header-3">{{propertiesLabel}}</h3>
    </div>
    <div class="lm-facade-detail-content scrollable-y">
    <div class="lm-facade-detail-empty-message">
        <svg class="icon-empty-state" focusable="false" aria-hidden="true" role="presentation">
            <use href="#icon-empty-new-project-new"></use>
        </svg>
        <header><p class="lm-bold">{{ emptyTitle }}</p></header>
    </div>
    </div>
    <div class="lm-facade-detail-footer">
        <button soho-button="primary" [disabled] ="true">{{ 'Facade_StartReport' | translate }}</button>
    </div>
</div>

